import { mergeDeep } from '@sitecore-search/common';
const getKey = (rfkId, entity) => `${rfkId}${entity ? `@${entity}` : ''}`;
const WidgetsConfig = {
    widgetTypesConfigMapping: {},
    widgetsConfigMapping: {},
    setWidgetType(type, mapping) {
        mergeDeep(this.widgetTypesConfigMapping, { [type]: mapping }, { mutate: true });
    },
    getType(rfkId) {
        const { type } = this.widgetsConfigMapping[getKey(rfkId)] || {};
        return type;
    },
    set(rfkId, entityOrConfig, config) {
        if (typeof entityOrConfig === 'string') {
            this.widgetsConfigMapping[getKey(rfkId, entityOrConfig)] = config;
        }
        else {
            this.widgetsConfigMapping[getKey(rfkId)] = entityOrConfig;
        }
    },
    update(rfkId, entity, config) {
        if (typeof entity === 'string') {
            mergeDeep(this.getOrCreate(rfkId, entity), config, { mutate: true });
        }
        else {
            mergeDeep(this.getOrCreate(rfkId), config, { mutate: true });
        }
    },
    get(rfkId, entity) {
        const widgetIdEntityConfig = this.widgetsConfigMapping[getKey(rfkId, entity)];
        const widgetIdConfig = this.widgetsConfigMapping[getKey(rfkId)];
        if (!widgetIdConfig && !widgetIdEntityConfig) {
            return undefined;
        }
        const widgetConfig = mergeDeep(widgetIdConfig || {}, widgetIdEntityConfig || {});
        const { component: TypeComponent, options: typeOptions } = this.getForType(rfkId) || {};
        const { component = TypeComponent, options } = widgetConfig;
        return {
            ...widgetConfig,
            component,
            options: options ? mergeDeep(typeOptions || {}, options) : typeOptions,
        };
    },
    getWidgetIds() {
        return Object.keys(this.widgetsConfigMapping);
    },
    getByType(type) {
        return this.widgetTypesConfigMapping[type] || undefined;
    },
    getForType(rfkId) {
        const type = this.getType(rfkId);
        return type ? this.getByType(type) : undefined;
    },
    getOrCreate(rfkId, entity) {
        if (!this.widgetsConfigMapping[getKey(rfkId, entity)]) {
            this.widgetsConfigMapping[getKey(rfkId, entity)] = {};
        }
        return this.widgetsConfigMapping[getKey(rfkId, entity)];
    },
    getMetadata(rfkId) {
        const { metadata } = this.widgetsConfigMapping[getKey(rfkId)] || {};
        return metadata;
    },
    setMetadata(rfkId, metadata) {
        Object.assign(this.getOrCreate(rfkId), { metadata });
        this.setType(rfkId, metadata.type);
    },
    updateMetadata(rfkId, metadata) {
        mergeDeep(this.getOrCreate(rfkId), { metadata }, { mutate: true });
        this.setType(rfkId, metadata.type);
    },
    setType(rfkId, type) {
        if (!this.getType(rfkId)) {
            Object.assign(this.getOrCreate(rfkId), { type });
        }
    },
};
export default WidgetsConfig;
